<template>
    <div class="create">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="865px" :before-close="handleClose">
            <div class="main" v-loading="load">
                <div v-if="info">
                    <el-form label-width="100px" inline label-position="left">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="编号ID："> {{ info.detail.id }} </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="监控时间：">
                                    {{ info.detail.create_time }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="经销商名称："> {{ tag == 0 ? info.agency[0].name : info.agency.name }} </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="监控类型：">
                                    <p v-if="tag == 2 || tag == 3 || tag == 1">
                                        {{ info.detail.content }}
                                    </p>
                                    <p v-else-if="tag == 6 || tag == 7">{{ info.detail.extra }}</p>
                                    <p v-else>敏感词</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="负责人姓名："> {{ tag == 0 ? info.agency[0].principals_name : info.agency.principals_name }} </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="负责人电话："> {{ tag == 0 ? info.agency[0].principals_phone : info.agency.principals_phone }} </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="异常内容：">
                                    <el-form-item v-if="tag == 0">
                                        <p style="color: red">{{ info.detail.word }}</p>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-link @click="openUrl(info.detail.url)">{{ info.detail.url }}</el-link>
                                    </el-form-item>
                                    <el-form-item>
                                        <span class="shop" v-if="info.detail.shop_name">{{ info.detail.shop_name }}</span>
                                        <el-link type="primary" @click="viewImage(info.detail.image)">点击查看</el-link></el-form-item
                                    >
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="logBox" v-if="info.history.length > 0">
                        <p class="subtitle">历史记录</p>
                        <div class="logList">
                            <el-divider></el-divider>
                            <el-form label-width="100px" inline label-position="left" v-for="(item, index) in info.history" :key="index">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="编号ID："> {{ item.id }} </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="监控时间："> {{ item.create_time }} </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="经销商名称："> {{ tag == 0 ? info.agency[0].name : info.agency.name }} </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="监控类型：">
                                            <p v-if="tag == 2 || tag == 3 || tag == 1">
                                                {{ labelList[item.type] }}
                                            </p>
                                            <p v-else-if="tag == 6 || tag == 7">{{ item.extra }}</p>
                                            <p v-else>敏感词</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="负责人姓名："> {{ tag == 0 ? info.agency[0].principals_name : info.agency.principals_name }} </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="负责人电话："> {{ tag == 0 ? info.agency[0].principals_phone : info.agency.principals_phone }} </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="异常内容：">
                                            <el-form-item v-if="tag == 0">
                                                <p style="color: red">{{ item.word }}</p>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-link @click="openUrl(item.url)">{{ item.url }}</el-link>
                                            </el-form-item>
                                            <el-form-item>
                                                <span class="shop" v-if="info.detail.shop_name">{{ info.detail.shop_name }}</span>
                                                <el-link type="primary" @click="viewImage(item.image)">点击查看</el-link></el-form-item
                                            >
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                            </el-form>
                        </div>
                    </div>
                </div>
                <el-empty description="暂无内容！" v-else></el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" type="" size="medium" plain>关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 查看图片 -->
        <el-dialog :visible.sync="imgDialogVisible">
            <img v-if="dialogImageUrl" width="100%" :src="dialogImageUrl" alt="" />
            <el-empty v-else description="暂无图片！"></el-empty>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    name: "Detail",
    data() {
        return {
            dialogVisible: false,
            imgDialogVisible: false,
            dialogImageUrl: "",
            info: null,
            load: false,
            labelList: ["授权取消", "授权过期", "暂停授权"],
            tag: 0,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            getAuthorizationDetail: "brand/getAuthorizationDetail", //  授权详情
            getSensitiveWordDetail: "brand/getSensitiveWordDetail", //  敏感词详情
            getSellDetail: "brand/getSellDetail", //违规销售详情
            getIllegalDetail: "brand/getIllegalDetail", //违规串货详情
        }),
        openUrl(url) {
            window.open(url);
        },
        getDetail(id, tag) {
            this.tag = tag;
            let url;
            switch (Number(tag)) {
                case 0:
                    url = this.getSensitiveWordDetail;
                    break;
                case 1:
                    url = this.getAuthorizationDetail;
                    break;
                case 2:
                    url = this.getAuthorizationDetail;
                    break;
                case 3:
                    url = this.getAuthorizationDetail;
                    break;
                case 6:
                    url = this.getSellDetail;
                    break;
                case 7:
                    url = this.getIllegalDetail;
                    break;
                default:
                    break;
            }
            this.load = true;
            url({ id: id, token: this.getToken }).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.info = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        viewImage(url) {
            this.imgDialogVisible = true;
            this.dialogImageUrl = url;
        },
        handleClose() {
            this.info = null;
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    height: 480px;
    overflow-y: auto;
    &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
    }
}
.main {
    .logBox {
        padding: 15px;
        background: #eee;
        .subtitle {
            color: #333;
            font-size: 16px;
            margin-bottom: 12px;
        }
        .logList {
            ::v-deep .el-descriptions__body {
                background: #eee;
            }
        }
    }
}
.red {
    color: #f00;
}
::v-deep .el-form-item {
    margin-bottom: 0 !important;
    width: 100%;
}
.el-col-24 {
    ::v-deep .el-form-item__content {
        width: 80% !important;
    }
}
::v-deep .el-link {
    line-height: 24px;
}
.shop {
    margin-right: 20px;
}
.el-col {
    overflow: hidden;
    .el-form-item {
        margin: 0 !important;
    }
}
</style>